let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6gxk3")).then(() => parcelRequire('iq8b4'));